import webpush from 'web-push';
import axios from "axios";
/**
 * Handler notifications
 * @export
 * @class Notifications
 */
export default class Notifications {
    /**
     * Creates an instance of Notifications.
     * @memberof Notifications
     */
    constructor(vapidKeys) {
        this.notificationsAreSupported = true;
        this.vapidKeys = vapidKeys;
    }
    /**
     * Check if Notifications are Supported
     *
     * @memberof Notifications
     */
    checkIfNotificationsAreSupported() {
        if (!('serviceWorker' in navigator)) {
            // Service Worker isn't supported on this browser, disable or hide UI.
            this.notificationsAreSupported = false;
        }
        if (!('PushManager' in window)) {
            // Push isn't supported on this browser, disable or hide UI.
            this.notificationsAreSupported = false;
        }
        if (!('showNotification' in ServiceWorkerRegistration.prototype)) {
            // Notifications aren't supported.
            this.notificationsAreSupported = false;
        }
    }
    /**
     * Ask Permission
     *
     * Before we can show notifications, we must get permission from the user.
     * @memberof Notifications
     */
    askPermission() {
        return new Promise(function (resolve, reject) {
            const permissionResult = Notification.requestPermission(function (result) {
                resolve(result);
            });
            if (permissionResult) {
                permissionResult.then(resolve, reject);
            }
        });
    }
    /**
     * Register service-worker
     *
     *
     * @memberof Notifications
     */
    registerServiceWorker() {
        return navigator.serviceWorker.register(window.location.origin + '/service-worker.js')
            .then(function (registration) {
            // console.log('Service worker successfully registered.');
            return registration;
        })
            .catch(function (err) {
            console.error('Unable to register service worker.', err);
        });
    }
    /**
     * @memberof Notifications
     */
    urlBase64ToUint8Array(base64String) {
        const padding = '='.repeat((4 - (base64String.length % 4)) % 4);
        const base64 = (base64String + padding).replace(/\-/g, '+').replace(/_/g, '/');
        const rawData = window.atob(base64);
        const outputArray = new Uint8Array(rawData.length);
        for (let i = 0; i < rawData.length; ++i) {
            outputArray[i] = rawData.charCodeAt(i);
        }
        return outputArray;
    }
    /**
     * @memberof Notifications
     */
    saysWho() {
        const { userAgent } = navigator;
        let match = userAgent.match(/(opera|chrome|safari|firefox|msie|trident(?=\/))\/?\s*(\d+)/i) || [];
        let temp;
        if (/trident/i.test(match[1])) {
            temp = /\brv[ :]+(\d+)/g.exec(userAgent) || [];
            return `IE ${temp[1] || ''}`;
        }
        if (match[1] === 'Chrome') {
            temp = userAgent.match(/\b(OPR|Edge)\/(\d+)/);
            if (temp !== null) {
                return temp.slice(1).join(' ').replace('OPR', 'Opera');
            }
            temp = userAgent.match(/\b(Edg)\/(\d+)/);
            if (temp !== null) {
                return temp.slice(1).join(' ').replace('Edg', 'Edge (Chromium)');
            }
        }
        match = match[2] ? [match[1], match[2]] : [navigator.appName, navigator.appVersion, '-?'];
        temp = userAgent.match(/version\/(\d+)/i);
        if (temp !== null) {
            match.splice(1, 1, temp[1]);
        }
        return match.join(' ');
    }
    /**
     * @memberof Notifications
     */
    saveEndpointToDatabase(pushData, data) {
        let params = new URLSearchParams();
        params.set('pushData', pushData);
        params.set('data', data);
        params.set('browser', this.saysWho());
        axios
            .post('/save-endpoint', params)
            .then((response) => {
            if (response.status === 200) {
                if (response.data) {
                }
            }
        })
            .catch((error) => {
        });
    }
    /**
     * @memberof Notifications
     */
    init(data) {
        this.checkIfNotificationsAreSupported();
        if (this.notificationsAreSupported) {
            let self = this;
            webpush.setVapidDetails("mailto:office@semperitgroup.com", this.vapidKeys.vapidPublicKey, this.vapidKeys.vapidPrivateKey);
            this.registerServiceWorker().then(async (serviceWorker) => {
                if (serviceWorker instanceof ServiceWorkerRegistration && Notification.permission === 'granted') {
                    let push = await serviceWorker.pushManager.subscribe({
                        userVisibleOnly: true,
                        applicationServerKey: self.urlBase64ToUint8Array(self.vapidKeys.vapidPublicKey)
                    });
                    console.log(push);
                    console.log(data);
                    self.saveEndpointToDatabase(JSON.stringify(push), JSON.stringify(data));
                }
            });
        }
    }
}
